import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { SECTIONS, reportActions } from '../../../store/reportStore'
import { withLocalize } from 'react-localize-redux';
import { Translate } from 'react-localize-redux';
import classnames from 'classnames';
import OldStyleTableWithHistory from '../../common/oldStyleTableWithHistory';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import Paging from '../../common/pagingComponent';
import CustomTooltip from "../../common/customTooltip";

import './warningsSubSection.scss';

class WarningsSubSection extends React.Component {
    state = {
        historyExpanded: false,
        expandMap: {},
        shouldExpandMap: {},
        page: 1
    };
    dataRefMap = {};

    get section() {
        return this.props.sections.find(o => o.id === this.props.sectionId).subsections.find(q => q.id === this.props.subsectionId);
    }

    get pageSize() {
        const limits = this.props.getSectionLimits(this.props.reportType, this.props.subsectionId);
        return this.section.isLimited ? limits.pageSize.limited : limits.pageSize.unlimited;
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.isExpandAllActivated !== prevProps.isExpandAllActivated || this.props.isHideAllActivated !== prevProps.isHideAllActivated)
            this.setState({ isHistoryExpandedTouched: false });

        const data = this.section.data;

        if (data) {

            var prevActual = null;
            var prevHistorical = null;

            if (this.prevProps) {
                const prevSection = this.prevProps.sections.find(o => o.id === this.prevProps.sectionId);
                if (prevSection) {
                    var prevSubsection = prevSection.subsections.find(q => q.id === this.prevProps.subsectionId);
                    if (prevSubsection) {
                        var prevData = prevSubsection.data;
                        if (prevData) {
                            prevActual = prevData.warningsActual;
                            prevHistorical = prevData.warningsHistorical;
                        }
                    }
                }
            }

            // run resize only if needed
            if (((prevActual === null || prevActual === undefined) && (data.warningsActual !== null && data.warningsActual !== undefined)) ||
                ((prevHistorical === null || prevHistorical === undefined) && (data.warningsHistorical !== null && data.warningsHistorical !== undefined)) ||
                ((prevActual || []).length !== (data.warningsActual || []).length) || ((prevHistorical || []).length !== (data.warningsHistorical || []).length) ||
                prevState.historyExpanded !== this.state.historyExpanded) {
                this._debounce = window.setTimeout(() => this.updateSize(), 250);
            }
        }
    }

    componentDidMount() {
        this.test = window.addEventListener('resize', this.onResize, false)
        this.updateSize();
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.onResize, false)
    }

    updateSize = () => {
        this._debounce = undefined;
        if (this.dataRefMap === null || this.dataRefMap === undefined || Object.keys(this.dataRefMap).length === 0) {
            return;
        }
        let shouldExpandMap = { ...this.state.shouldExpandMap };
        let runSetState = false;
        const keys = Object.keys(this.dataRefMap);
        for (let idx = 0; idx < keys.length; idx++) {
            const se = this.dataRefMap[keys[idx]].offsetWidth < this.dataRefMap[keys[idx]].scrollWidth;
            if (shouldExpandMap[keys[idx]] !== se && !this.state.expandMap[keys[idx]]) {
                shouldExpandMap[keys[idx]] = se;
                runSetState = true;
            }
        }
        if (runSetState) {
            this.setState({ shouldExpandMap });
        }
    }

    onResize = e => {
        if (this._debounce !== null && this._debounce !== undefined) {
            window.clearTimeout(this._debounce);
        }
        this._debounce = window.setTimeout(() => this.updateSize(), 250);
    }

    render() {
        if (this.section.name === undefined || this.section.name === null)
            return null;

        const { data, loadingMoreData, isLimited } = this.section;
        if (isNullOrUndefined(data))
            return null;

        const countProp = this.props.subsectionId.replace(SECTIONS.shortReport, '').replace(SECTIONS.warningsReport, '');

        const totalCount = this.props.getParentSection([this.props.sectionId, this.props.subsectionId]).data[countProp + 'Count'];

        const max = totalCount > this.pageSize * this.state.page ? this.pageSize * this.state.page : totalCount;

        return (
            <>
                <OldStyleTableWithHistory offsetLeft={false} isLimited={isLimited}
                    head={this.renderHead} tableColumns={7} onHistoryToggle={this.onHistoryToggle} stripped
                    actualData={data.warningsActual} actualRow={(r) => this.renderWarningRow(r, false)}
                    historyData={data.warningsHistorical} historyRow={(r) => this.renderWarningRow(r, true)}
                    resolveExpanded={this.props.resolveExpanded}
                />
                {isLimited && totalCount > max && this.renderMoreLinks(totalCount, loadingMoreData)}
                {!isLimited && totalCount > this.pageSize && <div style={{ marginTop: "2em" }}>
                    <Paging
                        justify="center"
                        selectedPage={this.state.page}
                        totalPages={Math.ceil(totalCount / this.pageSize)}
                        setPage={page => this.onChangePage(page)}
                    />
                </div>}
            </>
        )
    }

    onHistoryToggle = (historyExpanded) => {
        this.setState({ historyExpanded })
    }

    renderHead = () => {
        return (
            <thead className="warnings-header">
                <tr>
                    <th className="col-1"><Translate id="Report.GeneralAssemblies.Type" /></th>
                    <th className="col-2"><Translate id="Report.Common.Warning" /></th>
                    <th className="col-3"><Translate id="Report.Common.Source" /></th>
                    <th className="col-4" style={{ textAlign: 'right' }}><Translate id="Report.Common.Date" /></th>
                    <th className="col-5" style={{ textAlign: 'right' }}><Translate id="Report.Common.EndDate" /></th>
                    <th className="col-6" style={{ textAlign: 'right' }}><Translate id="Report.Common.Value" /></th>
                    <th className="col-7"><Translate id="Report.Common.Note" /></th>
                </tr>
            </thead>
        );
    }

    renderWarningRow = (item, isHistory) => {
        return (
            <tr key={item.id} className={classnames('colorize', { 'old-style-table-report-history-row': isHistory })}>
                <td>{item.shortening}</td>
                <td>{item.description}</td>
                <td id={"historyRow" + item.id}>
                    {item.url != null ? <span className={classnames('link-external', { 'is-normal': localStorage.locales_url_format === 'normal' })}>
                        <a href={item.url} target="_blank"> {item.source}</a>
                    </span> : <span>{item.source}</span>}
                    <CustomTooltip textAlign="right" placement='left' id={"historyRow" + item.id} text={item.sourceDescription} hideIcon delay={{ "show": 0, "hide": 0 }} innerClassName='tooltipSection'>
                    </CustomTooltip>
                </td>
                <td style={{ textAlign: 'right' }}>{item.startDateFormated}</td>
                <td style={{ textAlign: 'right' }}>{item.endDateFormated}</td>
                <td style={{ textAlign: 'right' }}>{item.value}</td>
                <td className='warning-note'>
                    <span className={classnames({ 'text-shorten': !this.state.expandMap[item.id] })}>
                        <p ref={el => this.dataRefMap[item.id] = this.dataRefMap[item.id] || el}>{this.renderInsolvencyLink(item.note)}</p>
                        {!this.state.expandMap[item.id] && this.state.shouldExpandMap[item.id] && <span className="link-functional" onClick={() => this.showLess(item.id)}><Translate id="Report.Common.More" /></span>}
                        {this.state.expandMap[item.id] && <span className="link-functional" style={{ float: 'right' }} onClick={() => this.showLess(item.id)}><Translate id="Report.Common.Less" /></span>}
                    </span>
                </td>
            </tr>
        );
    }

    getMore = () => {
        this.props.fetchMoreData(
            [this.props.sectionId, this.props.subsectionId],
            { count: this.pageSize, offset: this.pageSize, report: this.props.reportType, type: this.props.subsectionData.type, withHistory: true },
            null, this.concatData, () => this.setState({ page: 2 })
        );
    }

    onChangePage = (page) => {
        this.props.fetchMoreData(
            [this.props.sectionId, this.props.subsectionId],
            { count: this.pageSize, offset: (page - 1) * this.pageSize, report: this.props.reportType, type: this.props.subsectionData.type, withHistory: true },
            null, this.replaceData, () => this.setState({ page: page })
        );
    }

    renderMoreLinks = (totalCount, isLoading) => {
        return (
            <>
                <div>
                    {this.state.page === 1 && <span className="link-functional" onClick={() => this.getMore()}>
                        <Translate id="Report.Common.More" />
                    </span>}
                    {this.state.page === 2 && <a className="link-functional" target="_blank"
                        href={this.props.getUnlimitedSectionLink(this.props.reportType, this.props.id, this.props.sectionId)}
                    >
                        <Translate id="Report.Common.ShowAll" />&nbsp;({totalCount})
                    </a>}
                </div>
                {isLoading && <div style={{ width: "100%" }} className="search-progress searching"></div>}
            </>
        )
    }

    concatData = (_hint, oldData, newData) => {
        oldData.warningsActual = oldData.warningsActual.concat(newData.warningsActual);
        oldData.warningsHistorical = oldData.warningsHistorical.concat(newData.warningsHistorical);
        return oldData;
    }

    replaceData = (_hint, _oldData, data) => data;

    showLess = (id) => {
        let expandMap = { ...this.state.expandMap };
        expandMap[id] = !expandMap[id];
        this.setState({ expandMap });
    }

    renderInsolvencyLink = (note) => {
        const validationRegex = /^INS \d+\/\d{4}$/;
        if (validationRegex.test(note).valueOf()) {
            const params = note.replace('INS ', '').split('/');
            let href = `https://isir.justice.cz/isir/ueu/vysledek_lustrace.do?nazev_osoby=&vyhledat_pouze_podle_zacatku=on&podpora_vyhledat_pouze_podle_zacatku=true&jmeno_osoby=&ic=&datum_narozeni=&rc=&mesto=&cislo_senatu=&bc_vec=${params[0]}&rocnik=${params[1]}&id_osoby_puvodce=&druh_stav_konkursu=&datum_stav_od=&datum_stav_do=&aktualnost=AKTUALNI_I_UKONCENA&druh_kod_udalost=&datum_akce_od=&datum_akce_do=&nazev_osoby_f=&rowsAtOnce=50&spis_znacky_datum=&spis_znacky_obdobi=14DNI`;
            return <a href={href} className={classnames('link-external', { 'is-normal': localStorage.locales_url_format === 'normal' })} target="_blank">{note}</a>
        }
        return note;
    }
}

export default withLocalize(connect(
    state => state.report,
    dispatch => bindActionCreators(reportActions, dispatch)
)(WarningsSubSection));